module.exports = __webpack_public_path__ + "img/bg13.e6118620.jpg";